export default {
  USER: {
    ROLE: {
      SUPER: "Superuser",
      MANAGER: "Manager",
      SUPERVISOR: "Supervisor",
      OPERATOR: "Operator",
    },
  },
  ROUTE: {
    NAME: {
      MAIN: "main",
      PROJECT: "project",
      USER: "user",
      LOGIN: "login",
      REGISTER: "register",
      INVITE: "invite",
      PASSWORD: "password",
      TASK: "task",
      DATASET: "dataset",
      CREATETASK: "createtask",
      TASKPROGRESS: "taskprogress",
      NOTFOUND: "notFound",
      WORKSPACE: "workspace",
      TESTSPACE: "testspace",
      INTERFACE: "interface",
      DASHBOARD: "dashboard",
      CERTIFICATION: "certification",
      SiGNUP: "signup",
      SETTLEMENTS: "settlements",
      PROFILE: "profile",
      REQUESTPAPERS: "requestpapers",
      PRICESETTING: "pricesetting",
      FINDUSER: "finduser",
      ADMIN: "admin",
    },
    CODE: {
      SIGN: "M_SGN",
      PROJECT: "M_PROJ",
      DATASET: "M_DTS",
      USER: "M_USR",
      WORKSPACE: "M_WSP",
      INTERFACE: "M_ITF",
      DASHBOARD: "M_DBD",
      DASHBOARD_SUMMARY: "M_DBD_SUM",
      DASHBOARD_STATUS: "M_DBD_STS",
      DASHBOARD_MANAGER: "M_DBD_MNG",
      DASHBOARD_RESULT: "M_DBD_RST",
      DASHBOARD_DATASET: "M_DBD_DTS",
      MYPAGE: "M_DBD", // 현재 체크하는 로직이 없어서 기존 DASHBOARD에서 쓰고있는 걸로 체크
      WORK_MANAGEMENT: "M_WMN",
    },
  },
  TOKEN: {
    AUTH: "TOKEN_AUTHORIZATION",
    USER_DATA: "TOKEN_USER_DATA",
  },
  TASK: {
    CLASS_TYPE: {
      BOX: {
        icon: "/img/type_box.svg",
        text: "Box",
      },
      POLYGON: {
        icon: "/img/type_polygon.svg",
        text: "Polygon",
      },
      SINGLE_POINT: {
        icon: "/img/type_point.svg",
        text: "Point(single)",
      },
      GROUP_POINT: {
        icon: "/img/type_group_point.svg",
        text: "Point(group)",
      },

      ATTRIBUTE: {
        icon: "/img/type_attribute.svg",
        text: "Attribute",
      },
    },
  },
  TASK_ITEM: {
    WORK_STATUS: {
      WORK_BEFORE: {
        CODE: "WORK_BEFORE",
        TEXT: "작업 전",
        SOURCE: "/img/img_status_work_before.svg",
      },
      WORK_IN_PROGRESS: {
        CODE: "WORK_IN_PROGRESS",
        TEXT: "작업 중",
        SOURCE: "/img/img_status_work_in_progress.svg",
      },
      WORK_COMPLETE: {
        CODE: "WORK_COMPLETE",
        TEXT: "작업 완료",
        SOURCE: "/img/img_status_work_complete.svg",
      },
      DELETE_REQUEST: {
        CODE: "DELETE_REQUEST",
        TEXT: "삭제",
        SOURCE: "/img/img_status_delete_request.svg",
      },
      INSPECT_IN_PROGRESS: {
        CODE: "INSPECT_IN_PROGRESS",
        TEXT: "검수 중",
        SOURCE: "/img/img_status_inspect_in_progress.svg",
      },
      INSPECTING_BY_MANAGER: {
        CODE: "INSPECTING_BY_MANAGER",
        TEXT: "관리자 검수 중",
        SOURCE: "/img/img_status_inspect_in_progress.svg",
      },
      INSPECT_REJECT: {
        CODE: "INSPECT_REJECT",
        TEXT: "검수 반려",
        SOURCE: "/img/img_status_inspect_reject.svg",
      },
      INSPECT_COMPLETE: {
        CODE: "INSPECT_COMPLETE",
        TEXT: "검수 완료",
        SOURCE: "/img/img_status_inspect_complete.svg",
      },
      INSPECT_ALL_COMPLETE: {
        CODE: "INSPECT_ALL_COMPLETE",
        TEXT: "검수 완료(일괄)",
        SOURCE: "/img/img_status_inspect_complete.svg",
      },
      DELETE_COMPLETE: {
        CODE: "DELETE_COMPLETE",
        TEXT: "삭제 완료",
        SOURCE: "/img/img_status_delete_complete.svg",
      },
      DELETE_ALL_COMPLETE: {
        CODE: "DELETE_ALL_COMPLETE",
        TEXT: "삭제 완료(일괄)",
        SOURCE: "/img/img_status_delete_complete.svg",
      },
    },
  },
  WORKSPACE: {
    WORK_TYPE: {
      CODE: {
        작업자: "OPERATOR",
        검수자: "INSPECTOR",
        매니저: "MANAGER",
        뷰어: "VIEWER",
      },
      TEXT: {
        OPERATOR: "작업자",
        INSPECTOR: "검수자",
        MANAGER: "매니저",
        VIEWER: "뷰어",
      },
    },
  },
  ATTRIBUTE: {
    BANNED_WORDS: [
      "뭔가",
      "무언가",
      "어떤",
      "어떠한",
      "어느",
      "어딘가",
      "어디론가",
      "한국인",
      "흑인",
      "중국인",
      "아시아인",
      "미국인",
      "유럽인",
      "아랍인",
      "동양인",
      "피부색",
      "살색",
      "검정색",
    ],
    WARN_WORDS: [
      "사진이네요",
      "사진이에요",
      "사진이 보이네요",
      "사진이 있어요",
      "백인",
      "겨져",
      "여져",
      "혀져",
      "려져",
    ],
  },
  DATASET: {
    REGION: "ap-northeast-2",
    AWS_ACL: "public-read",
    DEVELOP: {
      IDENTITY_POOL_ID: "ap-northeast-2:8f02db98-c9dc-40ef-a7c6-e1636980d1b4",
      BUCKET: "ds-mowgli-data",
    },
    ACTIVE: {
      IDENTITY_POOL_ID: "ap-northeast-2:63f51d05-434d-4110-af37-b7009583aab5",
      BUCKET: "treed-data-active",
    },
    STABLE: {
      IDENTITY_POOL_ID: "ap-northeast-2:e7e6f7a3-2ddc-4125-b3f7-5fa7c0a9684e",
      BUCKET: "treed-data-stable",
    },
  },
  COLORS: [
    ["#FFDBDB", "#FDBABA", "#F69F9F", "#F1B2DF", "#FB8AC0", "#D9488E"],
    ["#FFF493", "#FDD97E", "#FFC01E", "#FFD2B1", "#FFB580", "#FF7E20"],
    ["#E3F18B", "#C8DA57", "#B1E4A0", "#9AECC5", "#7CDC96", "#4CAE6D"],
    ["#C9EBFF", "#A2DEF9", "#6AC9DE", "#CDDEFF", "#86C5FF", "#5689D7"],
    ["#EBC0FF", "#CA96F2", "#AD99D9", "#A27FEE", "#AFB2FE", "#8186F5"],
  ],
  ATTR_TYPE_LIST: ["단일 선택", "다중 선택", "문자 입력"],
  TEXT_TYPE_LIST: ["숫자", "글자", "단어"],

  COMMON_LIST_LIMIT: 10,
  COMMON_LIST_ORDER: "DESC",
};

export const allocationTypeMap = {
  INSPECTOR: "검수",
  OPERATOR: "작업",
};
